import styled from "styled-components";
import Highlight from "react-highlight";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  > * {
    margin: 1rem 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 1rem;
  > * {
    margin: 0 5px;
  }
  :last-child {
    margin-right: 5px;
  }
`;

export const DropzoneContainer = styled.div`
  width: auto;
  height: 100px;
  border: 2px dashed #dae6e8;
  background-color: ${({ theme }) => theme.greyBackground};;
  font-size: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 25px;
  outline: none;
`;

export const ResultContainer = styled.div`
  margin: 16px;
`;

export const ResultItemContainer = styled.div`
  padding: 16px;
  border: 1px solid #dae6e8;
`;

export const StyledHighlight = styled(Highlight)`
  font-size: 12px;
`;

export const HighlightContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f7f7f7;
  padding: 20px;
`;